enum Types {
    CLEAN_STORE="CLEAN_STORE",
    UPDATE_CONSULTATION="UPDATE_CONSULTATION",
    UPDATE_CONSULTATION_SUCCESS="UPDATE_CONSULTATION_SUCCESS",
    SET_CONSULTATIONS="SET_CONSULTATIONS",
    DOCTOR_LIST_SUCCESS="DOCTOR_LIST_SUCCESS"
}

export default Types;